var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"MeasureViewComponent"},[_vm._v(_vm._s(_vm.output)+" "+_vm._s(_vm.outputUnits))])
}
var staticRenderFns = []

export { render, staticRenderFns }